import React from 'react'
import { Vertical } from '@gravitate-js/excalibrr'
import { AllStatus } from './All/AllStatus'
import { SelectedStatus } from './Selected/SelectedStatus'
import { useDirectiveContext } from '../../DirectiveContext'

export const IntradayDirectiveStatus = ({ dailyDirectives, isDailyLoading, showModal }) => {
  const { selectedDirective, selectedPrice } = useDirectiveContext()
  const showAll = !selectedDirective && !selectedPrice
  return (
    <Vertical verticalCenter className='pl-4' flex={1}>
      <Vertical flex={1}>
        {showAll ? (
          <AllStatus dailyDirectives={dailyDirectives} isDailyLoading={isDailyLoading} />
        ) : (
          <SelectedStatus showModal={showModal} />
        )}
      </Vertical>
    </Vertical>
  )
}
